import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[5]}px;
  align-content: baseline;
`;

// export const Container = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(185px, 1fr));
//   gap: 16px;
//   width: 100%;
// `;
